import { Component, inject } from '@angular/core';
import { BaryComponentHelper } from '../shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { LoginModalType } from '../../models/enums/login-modal.enum';
import { TranslateDirective } from '../../directives/translate.directive';
import { LoginFormComponent } from './login-form/login-form.component';

@Component({
  selector: 'jhi-login-modal',
  standalone: true,
  imports: [TranslateDirective, LoginFormComponent],
  templateUrl: './login-modal.component.html',
})
export class LoginModalComponent {
  readonly #modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public description?: string;
  public loginType: LoginModalType = LoginModalType.LOGIN;

  close(): void {
    this.action.next(new BaryModalEvent({ close: true }));
    this.#modalRef.hide();
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }
}
